import { transliterationFor } from "./transliterate";

export type TranscriptLanguageMode = "both" | "hindi" | "english";

export const TRANSCRIPT_LANGUAGE_STORAGE_KEY = "supervision.transcriptLanguage";

/**
 * Choose the visible transcript lines without changing the stored transcript.
 *
 * "English" is the console's existing Latin-script reading of Hindi. It is deliberately
 * display-only; it is not a semantic translation and it never changes what the agent heard.
 */
export function transcriptText(text: string, mode: TranscriptLanguageMode) {
  const latin = transliterationFor(text);

  if (!latin || mode === "hindi") return { primary: text, secondary: null };
  if (mode === "english") return { primary: latin, secondary: null };
  return { primary: text, secondary: latin };
}
